import { render, staticRenderFns } from "./EmployeeCreateModal.vue?vue&type=template&id=5edfcaf5&scoped=true"
import script from "./EmployeeCreateModal.vue?vue&type=script&lang=ts"
export * from "./EmployeeCreateModal.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeCreateModal.vue?vue&type=style&index=0&id=5edfcaf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edfcaf5",
  null
  
)

export default component.exports